import React from 'react';
import Moment from 'moment';

import { Box } from '@mui/material';

import { ContentItem } from './types';

interface Props {
    item: ContentItem;
    format: 'json' | 'text';
}

const Generic: React.FC<Props> = ({ item, format }) => {
    if (format === 'text') {
        return <div>
            {Moment(new Date(item.timestamp)).format('h:mm A')}: {item.text_content}
        </div>;
    }
    const fromElement = (<>
        <div style={{ position: 'absolute', top: '5px', right: '5px', fontSize: '10px' }}>
            {Moment(new Date(item.timestamp)).format('h:mm A')}
        </div>
    </>);
    return (<Box sx={{ overflow: 'scroll', position: 'relative', fontFamily: 'Lato', fontSize: '12px', marginBottom: '16px', width: '100%', padding: '3px', backgroundColor: 'rgb(255,255,255)', border: '1px solid rgb(230,230,230)', borderRadius: '4px' }}>
        {fromElement}
        <div style={{ fontSize: '13px', position: 'relative', left: '0px', width: 'calc(100% - 0px)', color: 'rgb(0,0,0)', lineHeight: '1.0' }}>
            <div style={{ fontWeight: 'bolder' }}>{item.type}</div>
            <div>{item.text_content}</div>
            <div><pre>{JSON.stringify(item.data.data, null, 2) }</pre></div>
        </div>
    </Box>);
};

export default Generic;
